module.exports = __webpack_public_path__ + "static/media/logo-pure-white.893ad1cd.svg";